"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoomiOrderEntitlementStatusSchema = void 0;
exports.BoomiOrderEntitlementStatusSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        sonosId: {
            type: 'string'
        },
        transactionId: {
            type: 'string'
        },
        originalTransactionId: {
            type: 'string'
        },
        status: {
            enum: [
                'QUEUED',
                'PROVISIONED',
                'DE_PROVISIONED',
                'NOT_PROVISIONED',
                'DE_PROVISION_QUEUED'
            ],
            type: 'string'
        },
        source: {
            enum: [
                'APPLE',
                'Apple',
                'apple',
                'ZUORA',
                'Zuora',
                'zuora'
            ]
        }
    },
    required: [
        'originalTransactionId',
        'sonosId',
        'transactionId',
        'status',
        'source'
    ],
    type: 'object'
};
//# sourceMappingURL=data:application/json;base64,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